// Module
var code = "<li class=\"applied-filter\" ng-if=\"isConditionDisplaying()\">Contact <span>{{condition.exclude_from_report ? 'is NOT in' : 'is in'}}</span> Report <strong>{{displayReportName()}} </strong><strong><i class=\"icon-cross\" ng-click=\"remove()\"></i></strong></li>\n";
// Exports
module.exports = code;